webpackJsonp([193747675109532],{

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/people.3b02af1f.jpg";

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(77);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _people = __webpack_require__(534);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _peoplelogo = __webpack_require__(535);
	
	var _peoplelogo2 = _interopRequireDefault(_peoplelogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'PEOPLE AGENCY'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Generic Page' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'image midlogo' },
	                            _react2.default.createElement('img', { src: _peoplelogo2.default, alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _people2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Previamente denominada MM+A e com 16 anos de experi\xEAncia, a People \xE9 uma ag\xEAncia criativa centrada no branding e marketing digital, oferecendo tamb\xE9m servi\xE7os web, comunica\xE7\xE3o offline e audiovisual.'
	                    ),
	                    _react2.default.createElement(
	                        'center',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.people-agency.com/', className: 'button' },
	                            'Saber mais'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-people-js-f436f7e2e2b880f3771f.js